import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { Close } from '@mui/icons-material';
import ProduttoreCard from './ProduttoreCard';

export default function CreaProduttoreDialog({ onSaved, open, onClose }) {
  const [produttoreData, setProduttoreData] = useState(null);
  const produttoreCardRef = useRef(null);

  const handleSave = () => {
    produttoreCardRef.current.onSalva();
  };

  useEffect(() => {
    setProduttoreData(null);
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'hidden',
        }}
      >
        <DialogTitle>
          <Stack
            direction="row"
            spacing={2}
            justifyContent={'space-between'}
            alignItems="center"
          >
            <Typography variant="h6" color="primary">
              Nuovo Produttore
            </Typography>
            <Stack direction="row" spacing={2}>
              <Button variant="contained" size="small" onClick={handleSave}>
                SALVA
              </Button>

              <IconButton size="small" onClick={onClose}>
                <Close />
              </IconButton>
            </Stack>
          </Stack>
        </DialogTitle>
        <DialogContent sx={{ flexGrow: 1, overflowY: 'auto' }}>
          <ProduttoreCard
            ref={produttoreCardRef}
            isNewProduttore
            produttoreData={produttoreData}
            onSaved={onSaved}
            embedded
          />
        </DialogContent>
      </Box>
    </Dialog>
  );
}
